// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
    buttons
    ==========================================================================*/
.btn {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    padding: 5px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}
.btn:hover {
    background: var(--accent-light-hover);
}
.btn:active {
    box-shadow: 0 0 0 0.2rem rgba(151,217,204,.5);
}
.btn:focus-visible{
    outline: 1px solid var(--border-focused);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/form/common_style/arrow_button.css"],"names":[],"mappings":"AAAA;;+EAE+E;AAC/E;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,6CAA6C;AACjD;AACA;IACI,wCAAwC;AAC5C","sourcesContent":["/* =============================================================================\n    buttons\n    ==========================================================================*/\n.btn {\n    background: none;\n    border: none;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 5px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n}\n.btn:hover {\n    background: var(--accent-light-hover);\n}\n.btn:active {\n    box-shadow: 0 0 0 0.2rem rgba(151,217,204,.5);\n}\n.btn:focus-visible{\n    outline: 1px solid var(--border-focused);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
